import buildInfo from "./buildInfo";
let config = {
    buildInfo: buildInfo,
    genericRecipeUrl: "https://recipestoshare.org/defaultRecipePictures/generic-recipe.jpg"
};

export default config;